import { render } from "./Shape.vue?vue&type=template&id=41a54a60"
import script from "./Shape.vue?vue&type=script&lang=js"
export * from "./Shape.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__